export const DONATION_AMOUNTS_CONFIG = {
    case: {
        presetAmounts: [500, 100, 50],
        hasRemainingButton: true,
        minimumAmount: 5,
        currency: 'SAR'
    },
    
    campaign: {
        presetAmounts: [500, 100, 50],
        hasRemainingButton: true,
        minimumAmount: 5,
        currency: 'SAR'
    },

    waqf: {
        presetAmounts: [500, 100, 50],
        hasRemainingButton: true,
        minimumAmount: 5,
        currency: 'SAR'
    },
    
    periodic: {
        monthly: {
            presetAmounts: [500, 100, 50],
            minimumAmount: 5
        },
        daily: {
            presetAmounts: [50, 10, 5],
            minimumAmount: 5
        },
        hasRemainingButton: false,
        currency: 'SAR'
    },
    
    zakat: {
        presetAmounts: [],
        hasRemainingButton: false,
        minimumAmount: 5,
        maximumAmount: 9999999,
        currency: 'SAR'
    },
    
    gift: {
        presetAmounts: [500, 100, 50, 10],
        hasRemainingButton: false,
        minimumAmount: 5,
        currency: 'SAR'
    },
    
    comprehensive: {
        presetAmounts: [],
        hasRemainingButton: false,
        minimumAmount: null,
        currency: 'SAR'
    },

    // Wallet types are fetched dynamically from API: /wallet/get-to-wallets/?quick-donation=1
    // and each wallet type has its own independent preset amounts for future customization
    quickDonation: {
        mostUrgent: {
            presetAmounts: [500, 100, 50],
            minimumAmount: 5
        },
        zakat: {
            presetAmounts: [500, 100, 50],
            minimumAmount: 5
        },
        endowment: {
            presetAmounts: [500, 100, 50],
            minimumAmount: 5
        },
        custom: {
            presetAmounts: [500, 100, 50],
            minimumAmount: 5
        },
        hasRemainingButton: false,
        currency: 'SAR',
        note: 'Wallet types are dynamic and fetched from backend API. Configure amounts per wallet type above.'
    }
};

export const getChannelAmounts = (channel, period = null) => {
    const config = DONATION_AMOUNTS_CONFIG[channel];
    if (!config) return [];

    if ((channel === 'periodic' || channel === 'quickDonation') && period) {
        return config[period]?.presetAmounts || [];
    }

    return config.presetAmounts || [];
};

export const getMinimumAmount = (channel, period = null) => {
    const config = DONATION_AMOUNTS_CONFIG[channel];
    if (!config) return null;

    if ((channel === 'periodic' || channel === 'quickDonation') && period) {
        return config[period]?.minimumAmount ?? config.minimumAmount ?? null;
    }

    return config.minimumAmount ?? null;
};

export const hasRemainingButton = (channel) => {
    return DONATION_AMOUNTS_CONFIG[channel]?.hasRemainingButton ?? false;
};

export default DONATION_AMOUNTS_CONFIG;